import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const sitterApiService = createApi({
  reducerPath: 'sitterApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/sitter/'),
  endpoints: (builder) => ({
    getSitters: builder.query({
      query: (args) => {
        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let params = queryParams(args)

        return `get${params}`

      },
      keepUnusedDataFor: 0
    }),
    assignBadge: builder.mutation({
      query: (body) => ({
        url: `assign-badge/${body._id}`,
        method: "PUT",
        body
      })
    }),
    handleStatus: builder.mutation({
      query: (body) => ({
        url: `status/${body._id}`,
        method: "PUT",
        body
      })
    })
  })
})

export const {
  useGetSittersQuery,
  useAssignBadgeMutation,
  useHandleStatusMutation
} = sitterApiService